import { render, staticRenderFns } from "./subscribeSuccess.vue?vue&type=template&id=3b2b1b6e&scoped=true"
import script from "./subscribeSuccess.vue?vue&type=script&lang=js"
export * from "./subscribeSuccess.vue?vue&type=script&lang=js"
import style0 from "./subscribeSuccess.vue?vue&type=style&index=0&id=3b2b1b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b1b6e",
  null
  
)

export default component.exports